import React, { Component } from "react";
import PropTypes from "prop-types";
import FontAwesome from "react-fontawesome";

class HelpIconButtonWithTooltip extends Component {
  render() {
    return (
      <FontAwesome
        className={
          "question-mark pointer" +
          (this.props.iconSize ? " question-mark-" + this.props.iconSize : "")
        }
        style={{ textDecoration: "none" }}
        name="question-circle"
        onClick={this.props.onClick}
      />
    );
  }
}

HelpIconButtonWithTooltip.propTypes = {
  iconSize: PropTypes.oneOf(["xs", "sm"])
};

export default HelpIconButtonWithTooltip;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/icons/HelpIconButton.js